import type { PlanEvent } from "../../../../shared/types";
import { CATEGORY_BLOCK_COLORS } from "../../../../shared/types";
import { TIME_COL_W, HOUR_HEIGHT_PX, DAY_START_HOUR } from "../../utils/time-constants";
import { minutesToTime } from "../../hooks/drag-drop-helpers";

interface WeekGridGhostBlockProps {
  readonly ghostDate: string;
  readonly ghostTopPx: number;
  readonly durationMinutes: number;
  readonly event: PlanEvent;
  readonly days: readonly string[];
  readonly column?: number;
  readonly totalColumns?: number;
}

export function WeekGridGhostBlock({
  ghostDate,
  ghostTopPx,
  durationMinutes,
  event,
  days,
  column = 0,
  totalColumns = 1,
}: WeekGridGhostBlockProps) {
  const colIndex = days.indexOf(ghostDate);
  if (colIndex === -1) return null;

  const heightPx = (durationMinutes / 60) * HOUR_HEIGHT_PX;
  const clampedHeight = Math.max(heightPx - 2, 22);
  const colorClasses = CATEGORY_BLOCK_COLORS[event.category];
  const startMinutes = DAY_START_HOUR * 60 + (ghostTopPx / HOUR_HEIGHT_PX) * 60;
  const endMinutes = startMinutes + durationMinutes;
  const startTime = minutesToTime(Math.round(startMinutes));
  const endTime = minutesToTime(Math.round(endMinutes));

  const dayWidthCalc = `(100% - ${TIME_COL_W}px) / ${days.length}`;
  const subColWidth = `${dayWidthCalc} / ${totalColumns}`;

  return (
    <div
      className={`absolute rounded border-l-2 border-2 border-dashed opacity-80 px-1.5 pointer-events-none z-50 flex flex-col justify-center ${colorClasses}`}
      style={{
        top: `${ghostTopPx + 1}px`,
        height: `${clampedHeight}px`,
        left: `calc(${TIME_COL_W}px + ${colIndex} * ${dayWidthCalc} + ${column} * ${subColWidth} + 1px)`,
        width: `calc(${subColWidth} - 2px)`,
      }}
    >
      <span className="block truncate font-medium text-[11px] leading-tight">
        {event.title}
      </span>
      {clampedHeight >= 36 && (
        <span className="block truncate text-[10px] opacity-60 leading-tight">
          {startTime}–{endTime}
        </span>
      )}
    </div>
  );
}
